import "./Testimonials.scss";
import Slider from "react-slick";
import { Fragment } from "react";
import { FaArrowLeft } from "react-icons/fa6";
import { FaArrowRight } from "react-icons/fa6";
import { baseUrl } from "../../../utils/apiData";

function NextArrow(props) {
  const { onClick } = props;
  return (
    <button className="next" onClick={onClick}>
      <FaArrowRight />
    </button>
  );
}

function PrevArrow(props) {
  const { onClick } = props;
  return (
    <button className="prev" onClick={onClick}>
      <FaArrowLeft />
    </button>
  );
}

const Testimonials = ({ dataList }) => {
  const settings = {
    dots: true,
    fade: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <section className="testimonials_sec">
      <div className="content_wrap">
        <div className="fade_slide_wrap">
          <Slider {...settings}>
            {dataList?.map((data) => {
              return (
                <Fragment key={data._id}>
                  <div className="fade_slide">
                    <div className="img_wrap">
                      <img src={`${baseUrl}/${data?.image_1}`} alt="img" />
                    </div>
                    <div className="feed_wrap">
                      <p className="t-12 wow fadeInUp">{data?.title}</p>
                      <h4
                        style={{ color: `${data.textColor}` }}
                        className="wow fadeInUp"
                      >
                        {data?.small_description}
                      </h4>
                      <img
                        src={`${baseUrl}/${data?.image_2}`}
                        alt="logo"
                        className="wow fadeInUp"
                      />
                      <p
                        className="t-16 wow fadeInUp"
                        style={{ color: `${data.textColor}` }}
                      >
                        {data?.name}
                      </p>
                      <p
                        className="t-12 subtext wow fadeInUp"
                        style={{ color: `${data.textColor}` }}
                      >
                        {data?.position}
                      </p>
                    </div>
                  </div>
                </Fragment>
              );
            })}
          </Slider>
        </div>
       
      </div>
    </section>
  );
};

export default Testimonials;
